var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplay)?_c('a',{staticClass:"is-flex is-fullwidth mt-3",attrs:{"href":_vm.imageLink}},[_c('img',{staticClass:"is-landing-ad",attrs:{"src":_vm.imageSrc,"alt":"advertisement"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }